import { SchoolType } from './SchoolType';


export interface CoreEdlevoConfiguration {
    id: string
    baseAddress?: string
    licenseKey?: string
    onlyIncludeGovernedByMunicipal: boolean
    onlyIncludeSchoolsWithMunicipalityCode: boolean
    includePersonsWithProtectedAddressInformation: boolean
    municipalityCode?: string
    certificateThumbprint?: string
    startDateOffset: number
    notesFilter?: string
    schoolTypes: number
    groupType: EdlevoGroupType
    mentorGroupType: EdlevoMentorGroupType
    sensitiveFields: EdlevoSensitiveFields
}

export enum EdlevoGroupType {
    None = 0x0000,
    EducationGroup = 0x0001,
    ActivityBasedGroup = 0x0002
}

export enum EdlevoMentorGroupType {
    None = 0x0000,
    GroupBased = 0x0001,
    ClassBased = 0x0002,
}

export enum EdlevoSensitiveFields {
    None = 0x0000,
    Address = 0x0001,
    CivicNo = 0x0002,
    PersonalEmail = 0x0004,
    Custodian = 0x0008,
    BirthDate = 0x0010,
    PhoneNumber = 0x0020,
    Sex = 0x0040,

    All = 0x007f,
}

export const EdlevoGroupTypeOptions: EdlevoGroupType[] = [
    EdlevoGroupType.EducationGroup,
    EdlevoGroupType.ActivityBasedGroup
];

export const EdlevoMentorGroupTypeOptions: EdlevoMentorGroupType[] = [
    EdlevoMentorGroupType.GroupBased,
    EdlevoMentorGroupType.ClassBased
];

export const EdlevoSensitiveFieldsOptions: EdlevoSensitiveFields[] = [
    EdlevoSensitiveFields.Address,
    EdlevoSensitiveFields.PhoneNumber,
    EdlevoSensitiveFields.PersonalEmail,
    EdlevoSensitiveFields.BirthDate,
    EdlevoSensitiveFields.CivicNo,
    EdlevoSensitiveFields.Sex,
    EdlevoSensitiveFields.Custodian
];

export const EdlevoSchoolTypeOptions: SchoolType[] = [
    SchoolType.PRESCHOOL,
    SchoolType.PRESCHOOLCLASS,
    SchoolType.LEISURETIMECENTER,
    SchoolType.COMPULSORY,
    SchoolType.COMPULSORYSPECIALNEED,
    SchoolType.UPPERSECONDARY,
    SchoolType.UPPERSECONDARYSPECIALNEED,
    SchoolType.ADULTEDUCATION,
    SchoolType.ADULTEDUCATIONSPECIALNEED,
    SchoolType.WORKHIGHERVOCATIONAL,
    SchoolType.ADULTEDUCATIONSWEDISH,
    SchoolType.PRESCHOOLLEISURETIMECENTER,
];
